module.exports = __webpack_public_path__ + "931bc5e57d402b88137500d8af868cff.svg";